import React from 'react'
import { connect } from 'react-redux'
const LabelOnly = (props) => {
    const { label,customStyle } = props


    return (
        <label className={`${customStyle}`} >
            {label}
        </label>

    )
}

const mapStateToProps = (state) => {

    return {

    }
}

const mapDispatchToProps = {

}


export default connect(mapStateToProps, mapDispatchToProps)(LabelOnly)